import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth-routes/admin/comments')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/comment' })
  },
})
